/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Candidates_UnavailableInputs */

const vi_einvoice_candidates_unavailable = /** @type {(inputs: Einvoice_Candidates_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa lấy được danh sách từ MISA, nhập tay số hóa đơn.`)
};

/**

* @param {Einvoice_Candidates_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_candidates_unavailable = /** @type {((inputs?: Einvoice_Candidates_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Candidates_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_candidates_unavailable(inputs)
});